export const enum ESpecificationNames {
  groundMeatSize = 'groundMeatSize',
  roastSize = 'roastSize',
  steakThickness = 'steakThickness',
  steaksPerPack = 'steaksPerPack',
}

export const specificationsNames = {
  [ESpecificationNames.groundMeatSize]: 'Ground Meat Size',
  [ESpecificationNames.roastSize]: 'Roast Size',
  [ESpecificationNames.steakThickness]: 'Steak Thickness',
  [ESpecificationNames.steaksPerPack]: 'Steaks/Pack',
};

export const enum MeasurementUnit {
  pounds = 'pounds',
  inches = 'inches',
  none = 'none',
}

export const measurementUnitLabels = {
  [MeasurementUnit.pounds]: 'lb.',
  [MeasurementUnit.inches]: 'in.',
  [MeasurementUnit.none]: '',
};

export function getMeasurementLabel(unit: any) {
  return unit in measurementUnitLabels
    ? measurementUnitLabels[unit as MeasurementUnit]
    : '';
}
